import { TdlError } from "@torre-labs/material";
import Vue from "vue";
import { mapState } from "vuex";

import SkeletonMixin from "@/mixins/SkeletonsMixin";
import { CookieService } from "@/services";
import { Person } from "@/services/DTOs";
import { createLog } from "@/utils/TrackingUtil";

import AppBarWrapper from "@/components/layout/app-bar-wrapper/AppBarWrapper.vue";

export default Vue.extend({
  name: "error",
  components: {
    AppBarWrapper,
    TdlError
  },
  mixins: [SkeletonMixin],
  props: {
    statusCode: {
      type: Number,
      default: 404
    },
  },
  data() {
    return {
      reported: false
    };
  },
  computed: {
    authentication: () => ({ user: {}, id: "", ready: false }),
    user(): Person | undefined {
      return this.authentication.ready ? (this.authentication.user as Person) : undefined;
    },
    baseURL(): string {
      return `${process.env.VUE_APP_DISCOVERY_HOMEPAGES_URL}`;
    },
    ...mapState("users", ["authentication"])
  },
  watch: {
    user() {
      if (!this.reported) {
        this.reported = true;
        const error = this.getErrorMessage();
        createLog(this.$props.statusCode, encodeURIComponent(error), this.user);
      }
    }
  },
  methods: {
    goToHome(): void {
      window.location.href = this.baseURL;
    },
    getErrorMessage(): string {
      return typeof CookieService.getCookie("torre.last_error_path") === typeof undefined ?
        typeof this.$route.query.errorMessage === typeof undefined ? "" : String(this.$route.query.errorMessage)
        : String(CookieService.getCookie("torre.last_error_path"));
    }
  }
});
